import { render } from "./MouseArea.vue?vue&type=template&id=1c0124c5"
import script from "./MouseArea.vue?vue&type=script&lang=js"
export * from "./MouseArea.vue?vue&type=script&lang=js"

import "./MouseArea.vue?vue&type=style&index=0&id=1c0124c5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__